import React, { Component } from 'react';
import _validator from 'modules/validator';
import _AdminService from 'modules/AdminService';
import DropdownList from 'components/controls/DropdownList';
import _notification from 'modules/notification';
import { Card, Table, Modal, Tag, Collapse, InputNumber } from 'antd';
import PageHeader from 'components/enterprise/PageHeader';
import { routesAdmin } from 'routes/Routes';
import ConfirmPopupWithInput from '../popup/ConfirmPopupWithInput';
import MyInput from 'components/controls/MyInput';
import TextArea from 'components/controls/TextArea';
import { GENERAL_ERROR_MESSAGE } from 'constants/constants';
import ImageToBase64 from '../../components/controls/ImageToBase64';
import FileUpload from '../../components/controls/FileUpload';
import InputCheck from 'components/controls/InputCheck';
import CKEditorComponent from '../../components/controls/CKEditorComponent';
import _utils from '../../modules/Utils';
import PostConfigurationRow from './PostConfigurationRow';
import LoadingSpinner from 'components/enterprise/LoadingSpinner';
const { Panel } = Collapse;

class PostConfiguration_new extends Component {
    constructor(props) {
        super(props);
        this.state = {
            rowData: {},
            exams: [],
            typeList: [],
            categoryList: [],
            degreeList: [],
            selectedPostID: 0,
            selectePostData: [],
            loading: false,
            showModel: false,
            showMessageBox: false,
            Exam_Error: "",
            ageData: [],
            categoryAgeRelaxationData: [],
            degreeData: [],
            categoryFeeRelaxationData: [],
            ageLimitData: [],
            categoryVisible: [],
            categoryChecked: [],
            percentageData: [],
            gradeData: [],
        };
    }

    componentDidMount() {
        this.getAllExams();
        this.getAllCategory();
        this.getAllDegree();
        //this.getPostConfigurationData();

        // if(this.props.match.params.postID ? this.props.match.params.postID : 0){
        //     this.loadExamData(this.props.match.params.postID ? this.props.match.params.postID : 0);
        // }
    }

    //API operations
    getPostConfigurationData = async () => {
        try {
            this.setState({ loading: true }, async () => {
                try {
                    let portalConfiguration = await _AdminService.GetPostConfigurationData(this.state.selectedPostID, '');
                    console.log("GetPortalConfiguration Data: ", portalConfiguration.data.Obj.listPostConfiguration);
                    debugger
                    // console.log(_utils.groupJSONArrayOfObjectsByKey(portalConfiguration.data.Obj.listPostConfiguration, 'Type'));
                    let tempTypeLst = _utils.groupJSONArrayOfObjectsByKey(portalConfiguration.data.Obj.listPostConfiguration, 'Type');

                    //let tempAgeLimit = portalConfiguration.data.Obj.listPostConfiguration.filter((item) => item.Type == 'Age Limit');
                    let tempAge = portalConfiguration.data.Obj.listPostConfiguration.filter((item) => item.Type == 'Age');
                    let tempCategoryAgeRelaxation = portalConfiguration.data.Obj.listPostConfiguration.filter((item) => item.Type == 'Category Age');
                    let tempDegree = portalConfiguration.data.Obj.listPostConfiguration.filter((item) => item.Type == 'Qualification');
                    let tempCategoryFeeRelaxation = portalConfiguration.data.Obj.listPostConfiguration.filter((item) => item.Type == 'Category Fee');
                    let tempCategoryVisible = portalConfiguration.data.Obj.listPostConfiguration.filter((item) => item.Type == 'Category');
                    let tempPercentage = portalConfiguration.data.Obj.listPostConfiguration.filter((item) => item.Type == 'Qualification Percentage');
                    let tempGrade = portalConfiguration.data.Obj.listPostConfiguration.filter((item) => item.Type == 'Qualification Grade');

                    let arr = tempCategoryVisible
                        .filter(item => item && item.Value === 1)
                        .map(item => item.Name);

                    this.setState({
                        ...this.state,
                        rowData: portalConfiguration.data.Obj.listPostConfiguration,
                        //ageLimitData: tempAgeLimit,
                        ageData: tempAge,
                        categoryAgeRelaxationData: tempCategoryAgeRelaxation,
                        degreeData: tempDegree,
                        categoryFeeRelaxationData: tempCategoryFeeRelaxation,
                        categoryVisible: tempCategoryVisible,
                        typeList: [{ 'Id': 'Age', 'Name': 'Age' }, { 'Id': 'Category Relaxation', 'Name': 'Category Relaxation' }],
                        loading: false,
                        categoryChecked: arr,
                        percentageData: tempPercentage,
                        gradeData: tempGrade
                    });

                } catch (e) {
                    // TODO
                    this.setState({ loading: false });
                    console.log('Error: ', e);
                }
            });
        } catch (e) { }
    }

    getAllExams = async () => {
        try {
            this.setState({ loading: true }, async () => {
                try {
                    let examsList = await _AdminService.GetAllPost();
                    //console.log("categoryList Data: ", examsList.data);

                    this.setState({
                        ...this.state,
                        exams: examsList.data,
                        loading: false,
                    }, () => {
                        if (this.props.match.params.postID ? this.props.match.params.postID : 0) {
                            this.loadExamData(this.props.match.params.postID ? this.props.match.params.postID : 0);
                        }
                    });

                } catch (e) {
                    // TODO
                    this.setState({ loading: false });
                    console.log('Error: ', e);
                }
            });
        } catch (e) { }
    }

    getAllDegree = async () => {
        try {
            this.setState({ loading: true }, async () => {
                try {
                    let degreeList = await _AdminService.GetAllDegree();
                    //console.log("categoryList Data: ", categoryList.data);

                    const filteredDegreeList = degreeList.data.filter(x =>
                        x.ParentId == null
                    );

                    console.log('degree: ', filteredDegreeList);

                    const result = filteredDegreeList.reduce((acc, curr) => {
                        acc.push({
                            Id: curr.Id,
                            Name: curr.Qualification_Name
                        })
                        return acc
                    }, [])

                    this.setState({
                        ...this.state,
                        degreeList: result,
                        loading: false,
                    });

                } catch (e) {
                    // TODO
                    this.setState({ loading: false });
                    console.log('Error: ', e);
                }
            });
        } catch (e) { }
    }

    getAllCategory = async () => {
        try {
            this.setState({ loading: true }, async () => {
                try {
                    let categoryList = await _AdminService.GetAllCategory();
                    //console.log("categoryList Data: ", categoryList.data);

                    this.setState({
                        ...this.state,
                        categoryList: categoryList.data,
                        loading: false,
                    });

                } catch (e) {
                    // TODO
                    this.setState({ loading: false });
                    console.log('Error: ', e);
                }
            });
        } catch (e) { }
    }

    handleUpdate = async (input) => {

        console.log("Before Final Data: ", this.state.rowData);



        // if (this.validateFormData()) {
        //     return
        // }

        const params = {
            PostId: this.state.selectedPostID,
            listPostConfiguration: this.state.rowData
        }

        console.log("Final Data: ", params);

        //console.log("Final data: ", params);

        try {
            this.setState({ loading: true }, async () => {
                try {
                    const response = await _AdminService.AddUpdatePostConfiguration(params);
                    console.log("Post response: ", response);
                    if (response.status == 200) {
                        _notification.showMessage('success', "Post Configuration saved successfully.");
                        this.setState({
                            loading: false,
                            selectedPostID: 0
                        });
                        //this.getPortalConfigurations();
                    }
                    else {
                        _notification.showMessage('error', response.data.message);
                    }
                } catch (e) {
                    // TODO
                    this.setState({ loading: false });
                    console.log('Error: ', e);
                    _notification.showMessage('error', GENERAL_ERROR_MESSAGE);
                }
            });
        } catch (e) { }
    }


    onDataChangeHandler = itemData => {
       debugger
        let tempAllRows = this.state.rowData;
        let tempRow = tempAllRows.filter((item) => item.Id == itemData.Id);

        tempRow[0].Name = itemData.Name;
        tempRow[0].Value = itemData.Value;
        tempRow[0].RefId1 = itemData.RefId1;
        tempRow[0].ValueStr = itemData.ValueStr;

        // if (itemData.Value === 0) {
        //     let tempRowTemp = tempAllRows.filter((item) => item.Name == itemData.Name);

        //     for (let i = 0; tempRowTemp.length > i; i++) {
        //         tempRowTemp[i].Value = 0
        //     }
        // }

        let tempCategoryVisible = tempAllRows.filter((item) => item.Type == 'Category');

        let arr = tempCategoryVisible
            .filter(item => item && item.Value === 1)
            .map(item => item.Name);

        this.setState({ ...this.state, rowData: tempAllRows, categoryChecked: arr });
    };


    onStringDataChangeHandler = (itemData) => {
        let tempAllRows = this.state.rowData;
        let tempRow = tempAllRows.filter(item => item.Id == itemData.Id);
    
        for (let i = 0; tempRow.length > i; i++) {
            tempRow[0].ValueStr = itemData.ValueStr;
        }
    
        this.setState({ ...this.state, rowData: tempAllRows });
    };
    

    closeMessageBox = (value = false) => {
        this.setState({ showMessageBox: value });
    }

    onExamChange = (event) => {
        // this.setState({
        //     ...this.state,
        //     selectedPostID: event.target.value
        // });

        const selectedPost = this.state.exams.filter(x =>
            x.Id == event.target.value
        );

        try {
            this.setState({ selectedPostID: event.target.value, selectePostData: selectedPost[0] }, async () => {
                if (this.state.selectedPostID)
                    this.getPostConfigurationData();
            });
        } catch (e) { }
    }

    loadExamData = (postID) => {
        try {
            const selectedPost = this.state.exams.filter(x =>
                x.Id == postID
            );

            this.setState({ selectedPostID: postID, selectePostData: selectedPost[0] }, async () => {
                this.getPostConfigurationData();
            });
        } catch (e) { }
    }

    onChangDegree = e => {
        console.log(e.target.name, ' = ');
        console.log(e.target.props);
        // this.setState({
        //     otherInformation: {
        //         ...this.state.otherInformation,
        //         [e.target.name]: !this.state.otherInformation[e.target.name]
        //     },
        // });
    };

    validateFormData = () => {
        let body = this.state.rowData;

        this.setState({
            MinAgeError: "",
            MaxAgeError: "",
        });

        //console.log("Validate: ", body);

        let hasError = false;

        if (!body.Min_Age_Criteria) {
            this.setState({ MinAgeError: 'Please enter valid Min Age' });
            hasError = true
        }

        if (!body.Max_Age_Criteria) {
            this.setState({ MaxAgeError: 'Please enter valid Max Age' });
            hasError = true
        }

        if (body.Min_Age_Criteria && body.Max_Age_Criteria) {
            if (body.Min_Age_Criteria >= body.Max_Age_Criteria) {
                _notification.showMessage('error', "Minimum Age should be less than Maximum Age.");
                hasError = true
            }
        }

        return hasError;
    }



    render() {

        if (this.state.loading)
            return <LoadingSpinner/>

        return (

            <div className="admin-container p-4">
                <PageHeader
                    title="Set Post/Exam Configuration"
                    breadcrumbItems={[{ label: 'Dashboard', path: routesAdmin.dashboard.path }, { label: 'Registration' }, { label: 'Set Post/Exam Configuration' }]}
                />
                <div className="ent-panel max1200 m-auto">
                    <h4 className="heading4">Set Post/Exam Configuration</h4>
                    <div className="admin-inner-wrap p-3">
                        <div className="row flex-sm-row borderb mb-3 pb-3">
                            <div className="col-sm-4">
                                <DropdownList
                                    value={this.state.selectedPostID ? this.state.selectedPostID : 0}
                                    name="PostId"
                                    onChange={this.onExamChange}
                                    placeholder="Select Exam"
                                    heading={"Exam/Post"}
                                    className="w-100"
                                    wrapClass="wrap"
                                    isRequired={true}
                                    options={this.state.exams}
                                    errorState={this.state.Exam_Error}
                                    errorMessage={this.state.Exam_Error}
                                />
                            </div>
                        </div>
                        <div className="collapse-container">
                            {(this.state.selectedPostID && this.state.rowData.length) ?
                                <Collapse collapsible="header" defaultActiveKey={[1]} className="collapse-wrap">
                                    <Panel header="Other Age Relaxations (Optional)" key="1">
                                        {this.state.ageData.map((item, index) => (
                                            <div key={item.Id}>
                                                <PostConfigurationRow valueType="Default" nameIsReadOnly={true} key={item.Id} data={item} onDataChange={this.onDataChangeHandler} />
                                            </div>
                                        ))}
                                    </Panel>

                                    <Panel header="Applicable Categories" key="2">
                                        {this.state.categoryVisible.map((item, index) => (
                                            <div key={item.Id}>
                                                <PostConfigurationRow valueType="CheckBox" nameIsReadOnly={true} key={item.Id} data={item} dataList={this.state.categoryList} heading="ApplicableCategory" onDataChange={this.onDataChangeHandler} ItemName={item.Name}
                                                    HideOther={(this.state.selectePostData && this.state.selectePostData.IsCategoryMandatory !== undefined && this.state.selectePostData.IsCategoryMandatory === false && item.Name !== "N/A") ? false : true}
                                                    IsCategoryMandatory={(this.state.selectePostData && this.state.selectePostData.IsCategoryMandatory)} />
                                            </div>
                                        ))}
                                    </Panel>

                                    <Panel header="Age Relaxation for Categories" key="3">
                                        {this.state.categoryAgeRelaxationData.map((item, index) => (
                                            <div key={item.Id}>
                                                {
                                                    this.state.categoryChecked.includes(item.Name) ?
                                                        (
                                                            <PostConfigurationRow valueType="TextBox" nameIsReadOnly={true} key={item.Id} data={item} dataList={this.state.categoryList} heading="Category" onDataChange={this.onDataChangeHandler} ItemName={item.Name}
                                                                IsCategoryMandatory={(this.state.selectePostData && this.state.selectePostData.IsCategoryMandatory)} />
                                                        ) : (
                                                            <PostConfigurationRow valueType="TextBox" nameIsReadOnly={true} key={item.Id} data={item} dataList={this.state.categoryList} heading="Category" onDataChange={this.onDataChangeHandler} ItemName={item.Name}
                                                                IsCategoryMandatory={false} />
                                                        )
                                                }

                                            </div>
                                        ))}
                                    </Panel>

                                    <Panel header="Exam Fee Relaxation for Categories" key="4">
                                        {this.state.categoryFeeRelaxationData.map((item, index) => (
                                            <div key={item.Id}>
                                                {
                                                    this.state.categoryChecked.includes(item.Name) ?
                                                        (
                                                            <PostConfigurationRow valueType="TextBox" nameIsReadOnly={true} key={item.Id} data={item} dataList={this.state.categoryList} heading="Category" onDataChange={this.onDataChangeHandler} ItemName={item.Name} IsCategoryMandatory={(this.state.selectePostData && this.state.selectePostData.IsCategoryMandatory)} />
                                                        ) :
                                                        (
                                                            <PostConfigurationRow valueType="TextBox" nameIsReadOnly={true} key={item.Id} data={item} dataList={this.state.categoryList} heading="Category" onDataChange={this.onDataChangeHandler} ItemName={item.Name} IsCategoryMandatory={false} />
                                                        )
                                                }
                                            </div>
                                        ))}
                                    </Panel>

                                    <Panel header="Mandatory Qualifications" key="5">
                                        {this.state.degreeData.map((item, index) => (
                                            <div key={item.Id}>
                                                <PostConfigurationRow valueType="CheckBox" nameIsReadOnly={true} key={item.Id} data={item} dataList={this.state.degreeList} heading="Degree" onDataChange={this.onDataChangeHandler} ItemName={item.Name} HideOther={true}  />
                                            </div>
                                        ))}
                                    </Panel>

                                    <Panel header="Qualification Percentage" key="6">
                                        {this.state.percentageData.map((item, index) => (
                                            <div key={item.Id}>
                                                <PostConfigurationRow valueType="TextBox" nameIsReadOnly={true} key={item.Id} data={item} dataList={this.state.degreeList} heading="Degree" onDataChange={this.onDataChangeHandler} ItemName={item.Name} HideOther={true} IsCategoryMandatory={(this.state.selectePostData)} />
                                            </div>
                                        ))}
                                    </Panel>

                                    <Panel header="Qualification Grade" key="7">
                                        {this.state.gradeData.map((item, index) => (
                                            <div key={item.Id}>
                                                <PostConfigurationRow valueType="TextBoxWithString" nameIsReadOnly={true} key={item.Id} data={item} dataList={this.state.degreeList} heading="Degree" onDataChange={this.onDataChangeHandler} ItemName={item.Name} HideOther={true} IsCategoryMandatory={(this.state.selectePostData)} />
                                            </div>
                                        ))}
                                    </Panel>

                                </Collapse>
                                : <></>}
                        </div>
                    </div>
                    {(this.state.selectedPostID && this.state.rowData.length) ?
                        <div className="col-sm-12 buttonAlignCenter pt-4" >
                            <button type="button" onClick={this.handleUpdate} className="button-global button-primary large autoHeight"><span>Update Post Configuration</span></button>
                        </div>
                        : <></>
                    }
                </div>
                {this.state.showMessageBox &&
                    <Modal
                        centered={true}
                        width={400}
                        className="modelPopAnt admin-popup"
                        visible={this.state.showMessageBox}
                        onCancel={() => this.closeMessageBox(false)}
                        footer={false}
                    >
                        <ConfirmPopupWithInput
                            onCancel={() => this.closeMessageBox(false)}
                            onOk={this.onConfirmResetDatabase}
                            popupData={""}
                            header={<div className="heading5">Reset Database</div>}
                            message="Reset Database activity cannot be reversed, please take a backup of existing database before performing this activity."
                            noButtonText="Cancel"
                            yesButtonText="Reset"
                        />
                    </Modal>}
            </div>

        )
    };
}

export default PostConfiguration_new;